import { render } from "./CIDStaffWorkload.vue?vue&type=template&id=4b7120a7"
import script from "./CIDStaffWorkload.vue?vue&type=script&lang=js"
export * from "./CIDStaffWorkload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__